import { MprcFeedTypography } from "components/MprcFeedTypography";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

///
export const TitleDeleted = () => {
    const { pub: { title, deletedOn } } = useCardContext();

    return deletedOn
        ? (
            <MprcFeedTypography variant="title" component="div" noWrap={true} color="error">
                <span title={title}>{title}</span>
            </MprcFeedTypography>
        )
        : null;
};
